import { render, staticRenderFns } from "./BannerGeneral.vue?vue&type=template&id=417ec54e&scoped=true&"
import script from "./BannerGeneral.vue?vue&type=script&lang=js&"
export * from "./BannerGeneral.vue?vue&type=script&lang=js&"
import style0 from "./BannerGeneral.vue?vue&type=style&index=0&id=417ec54e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417ec54e",
  null
  
)

export default component.exports